/* eslint-disable no-undef */
import axios from 'axios';

export class WechatShareConfig {
  // { title, desc, link, imgUrl }
  constructor({ title, desc, link, imgUrl, hiddenShare }) {
    this.hiddenShare = hiddenShare;
    this.shareInfo = { title, desc, link: link || window.location.href, imgUrl };
    this.init();
  }
  async init() {
    await Promise.all([this.loadWeChatJS(), this.getWeChatConfig()]);
    this.configWeChatShare();
    this.configWeChat();
  }

  loadWeChatJS() {
    //   document.write("<script language=javascript src='//res.wx.qq.com/open/js/jweixin-1.4.0.js'></script>"); // 微信分享js
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
      script.onload = resolve;
      script.onerror = reject;
      document.getElementsByTagName('body')?.[0].appendChild(script);
    });
  }

  getWeChatConfig() {
    return new Promise((resolve, reject) => {
      axios
        .post('/stream-port/api/forward/weiXin', {
          url: encodeURIComponent(window.location.href),
          siteId: $$.module.data.room.siteId
        })
        .then((response) => {
          resolve((this.config = response?.data?.data?.[0]));
        })
        .catch(function(error) {
          console.log(error);
          reject(error);
        });
    });
  }

  configWeChat() {
    console.log('configWeChat');
    wx.config({
      debug: false,
      appId: this.config.appId,
      timestamp: this.config.timestamp, // 必填，生成签名的时间戳
      nonceStr: this.config.NonceStr, // 必填，生成签名的随机串
      signature: this.config.signature, // 必填，签名
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline']
      // 必填，需要使用的JS接口列表 声明
    });
  }
  // https://www.shmedia.tech/assets/putuo/images/logo.png
  configWeChatShare() {
    console.log('configWeChatShare');

    wx.error(function(res) {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      console.log('wx.error', res);
    });
    wx.ready(() => {
      console.log('wx.ready');
      // if (this.hiddenShare) {
      //   wx.hideMenuItems({
      //     menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:QZone'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      //   });
      //   return;
      // }
      if (wx.updateAppMessageShareData) {
        wx.updateAppMessageShareData({
          ...this.shareInfo,
          success: function() {
            // alert('分享给朋友成功');
          },
          cancel: function() {
            // alert('你没有分享给朋友');
          }
        });
      } else {
        wx.onMenuShareAppMessage({
          ...this.shareInfo,
          success: function() {
            // alert('分享给朋友成功!');
          },
          cancel: function() {
            // alert('你没有分享给朋友!');
          }
        });
      }
      //分享给朋友圈
      if (wx.updateTimelineShareData) {
        wx.updateTimelineShareData({
          ...this.shareInfo,
          success: function() {
            //alert('分享给朋友成功');
          },
          cancel: function() {
            //alert('你没有分享给朋友');
          }
        });
      } else {
        wx.onMenuShareTimeline({
          ...this.shareInfo,
          success: function() {
            //alert('分享给朋友成功');
          },
          cancel: function() {
            //alert('你没有分享给朋友');
          }
        });
      }
    });
  }
}

export class RmtShareConfig {
  constructor({ title, desc, link, imgUrl, hiddenShare }) {
    this.info = { title, summary: desc, link: link || window.location.href, imageUrl: imgUrl };
    this.hiddenShare = hiddenShare;
    this.init();
  }

  init() {
    if (this.hiddenShare) {
      // rmt?.configUI({
      //   header: {
      //     // enable: true, //是否显示标题条，默认：true
      //     more: 'dismiss'
      //   }
      // });
      return;
    }
    const room = $$.module.data.room;
    const isJa = room.siteId === '310106'
    console.log('room info', room);

    const configUI = {
      moreBox: {
        wechat: 'enable', //"分享到微信"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        wechatMoment: 'enable', //"分享到朋友圈"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        qq: 'enable', //"分享到QQ"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        qqZone: 'enable', //"分享到QQ空间"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        weibo: 'enable', //"分享到微博"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        copyLink: 'enable', //"拷贝链接"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        theme: 'dismiss', //字体/配色
        report: 'enable'
      }
    };
    if (isJa) {
      configUI.header = {
        enable: true, //是否显示标题条，默认：true
        back: 'enable', //"返回"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        close: 'dismiss', //"关闭"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        voice: 'dismiss', //"语音"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        more: 'enable', //"更多"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        title: room.roomSettingContent.roomInfo.roomTitle
      };
    }
    rmt.configUI(configUI);

    const shareData = {
      //设置"分享到微信"数据
      wechat: this.info,
      //设置"分享到朋友圈"数据
      wechatMoment: this.info,
      //设置"分享到QQ"数据
      qq: this.info,
      //设置"分享到QQ空间"数据
      qqZone: this.info,
      //设置"分享到微博"数据
      weibo: this.info
    };

    if (isJa) {
      // 海报 contentId房间id
      shareData.poster = {
        contentId: room.roomId
      };
    }

    rmt.configShare?.(shareData);
  }
}
